module.exports = __webpack_public_path__ + "static/img/dagen-nav.ef04e04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/dagen-nav.jpg
// module id = SgSg
// module chunks = 4